import { jsxs, jsx } from "react/jsx-runtime";
const IconNoteSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h7.586c.526 0 1.042-.214 1.414-.586L20.414 15c.372-.372.586-.888.586-1.414V6c0-1.654-1.346-3-3-3ZM6 19a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v7h-3c-1.654 0-3 1.346-3 3v3H6Zm11.586-4L15 17.586V16a1 1 0 0 1 1-1h1.586Z" })
    ]
  }
);
export {
  IconNoteSvg
};
